<template>
  <div>
      <div class="container">
        <div class="banner">
          <!--轮播-->
          <div class="lubMain">
            <el-carousel class="lub" :interval="5000" arrow="always">
              <el-carousel-item v-for="(item,index) in advertiseList" :key="index">
                <img class="lubPic" :src="item.picUrl" alt="">
              </el-carousel-item>
            </el-carousel>

          </div>

        </div>


      </div>       
      <div class="container"><ul class="tuitu"><li><a href=""><img src="../assets/1.jpg" alt=""></a></li><li><a href=""><img src="../assets/1.jpg" alt=""></a></li><li><a href=""><img src="../assets/1.jpg" alt=""></a></li><li><a href=""><img src="../assets/1.jpg" alt=""></a></li></ul>
      </div>
      
      <div class="Product">
         <div  class="Produc_top">
           <div  class="Produc_topl">
              <img src="../assets/1f.png" alt="">普通检验
            </div>
            <ul  class="Produc_topr">
              <li><a href="">糖尿病检测</a></li>
              <li><a href="">易感基因检测</a></li>
              <li><a href="">胎儿新生儿疾病筛查</a></li>
              <li><a href="">遗传学检测</a></li>
              <li><a href="">性激素检测</a></li>
              <li><a href="">更多</a></li>
            </ul>
         </div>
         <div  class="Produc_bottom">
           <div  class="Produc_bottoml">
              <div class="qiehuan">
                    <el-carousel trigger="click" indicator-position='none' height="295px">
                      <el-carousel-item v-for="item in dataimg" :key="item">
                        <img :src="item.src">
                      </el-carousel-item>
                    </el-carousel>
              </div>
              <ul  class="Produc_bottomlist">
                 <li><a href="">
                 <img src="../assets/3.jpg" alt="">
                </a></li><li><a href="">
                 <img src="../assets/3.jpg" alt="">
                </a></li><li><a href="">
                 <img src="../assets/3.jpg" alt="">
                </a></li><li><a href="">
                 <img src="../assets/3.jpg" alt="">
                </a></li><li><a href="">
                 <img src="../assets/3.jpg" alt="">
                </a></li><li><a href="">
                 <img src="../assets/3.jpg" alt="">
                </a></li>
              </ul>
           </div>
           <ul  class="Produc_bottomr">
             <li><a href="">
               <img src="../assets/1.jpg" alt="">
               <p class="title">叶酸代谢检测</p>
               <p class="price">¥40.00<span >¥80.00</span></p>
               </a></li><li><a href="">
               <img src="../assets/1.jpg" alt="">
               <p class="title">叶酸代谢检测</p>
               <p class="price">¥40.00<span >¥80.00</span></p>
               </a></li><li><a href="">
               <img src="../assets/1.jpg" alt="">
               <p class="title">叶酸代谢检测</p>
               <p class="price">¥40.00<span >¥80.00</span></p>
               </a></li><li><a href="">
               <img src="../assets/1.jpg" alt="">
               <p class="title">叶酸代谢检测</p>
               <p class="price">¥40.00<span >¥80.00</span></p>
               </a></li><li><a href="">
               <img src="../assets/1.jpg" alt="">
               <p class="title">叶酸代谢检测</p>
               <p class="price">¥40.00<span >¥80.00</span></p>
               </a></li><li><a href="">
               <img src="../assets/1.jpg" alt="">
               <p class="title">叶酸代谢检测</p>
               <p class="price">¥40.00<span >¥80.00</span></p>
               </a></li><li><a href="">
               <img src="../assets/1.jpg" alt="">
               <p class="title">叶酸代谢检测</p>
               <p class="price">¥40.00<span >¥80.00</span></p>
               </a></li><li><a href="">
               <img src="../assets/1.jpg" alt="">
               <p class="title">叶酸代谢检测</p>
               <p class="price">¥40.00<span >¥80.00</span></p>
               </a></li><li><a href="">
               <img src="../assets/1.jpg" alt="">
               <p class="title">叶酸代谢检测</p>
               <p class="price">¥40.00<span >¥80.00</span></p>
               </a></li><li><a href="">
               <img src="../assets/1.jpg" alt="">
               <p class="title">叶酸代谢检测</p>
               <p class="price">¥40.00<span >¥80.00</span></p>
               </a></li>
           </ul>
         </div>
      </div>
      <div class="Product">
         <div  class="Produc_top">
           <div  class="Produc_topl">
              <img src="../assets/2f.png" alt="">特殊检验
            </div>
            <ul  class="Produc_topr">
              <li><a href="">糖尿病检测</a></li>
              <li><a href="">易感基因检测</a></li>
              <li><a href="">胎儿新生儿疾病筛查</a></li>
              <li><a href="">遗传学检测</a></li>
              <li><a href="">性激素检测</a></li>
              <li><a href="">更多</a></li>
            </ul>
         </div>
         <div  class="Produc_bottom">
           <div  class="Produc_bottoml">
              <div class="qiehuan">
                 <el-carousel trigger="click" indicator-position='none' height="295px">
                      <el-carousel-item v-for="item in dataimg" :key="item">
                        <img :src="item.src">
                      </el-carousel-item>
                    </el-carousel>
              </div>
              <ul  class="Produc_bottomlist">
                 <li><a href="">
                 <img src="../assets/3.jpg" alt="">
                </a></li><li><a href="">
                 <img src="../assets/3.jpg" alt="">
                </a></li><li><a href="">
                 <img src="../assets/3.jpg" alt="">
                </a></li><li><a href="">
                 <img src="../assets/3.jpg" alt="">
                </a></li><li><a href="">
                 <img src="../assets/3.jpg" alt="">
                </a></li><li><a href="">
                 <img src="../assets/3.jpg" alt="">
                </a></li>
              </ul>
           </div>
           <ul  class="Produc_bottomr">
             <li><a href="">
               <img src="../assets/1.jpg" alt="">
               <p class="title">叶酸代谢检测</p>
               <p class="price">¥40.00<span >¥80.00</span></p>
               </a></li><li><a href="">
               <img src="../assets/1.jpg" alt="">
               <p class="title">叶酸代谢检测</p>
               <p class="price">¥40.00<span >¥80.00</span></p>
               </a></li><li><a href="">
               <img src="../assets/1.jpg" alt="">
               <p class="title">叶酸代谢检测</p>
               <p class="price">¥40.00<span >¥80.00</span></p>
               </a></li><li><a href="">
               <img src="../assets/1.jpg" alt="">
               <p class="title">叶酸代谢检测</p>
               <p class="price">¥40.00<span >¥80.00</span></p>
               </a></li><li><a href="">
               <img src="../assets/1.jpg" alt="">
               <p class="title">叶酸代谢检测</p>
               <p class="price">¥40.00<span >¥80.00</span></p>
               </a></li><li><a href="">
               <img src="../assets/1.jpg" alt="">
               <p class="title">叶酸代谢检测</p>
               <p class="price">¥40.00<span >¥80.00</span></p>
               </a></li><li><a href="">
               <img src="../assets/1.jpg" alt="">
               <p class="title">叶酸代谢检测</p>
               <p class="price">¥40.00<span >¥80.00</span></p>
               </a></li><li><a href="">
               <img src="../assets/1.jpg" alt="">
               <p class="title">叶酸代谢检测</p>
               <p class="price">¥40.00<span >¥80.00</span></p>
               </a></li><li><a href="">
               <img src="../assets/1.jpg" alt="">
               <p class="title">叶酸代谢检测</p>
               <p class="price">¥40.00<span >¥80.00</span></p>
               </a></li><li><a href="">
               <img src="../assets/1.jpg" alt="">
               <p class="title">叶酸代谢检测</p>
               <p class="price">¥40.00<span >¥80.00</span></p>
               </a></li>
           </ul>
         </div>
      </div>

  </div>

</template>

<script>
  export default {
    name: "home-page2",

    data() {
      return {
        dataimg: [{
						src: require('../assets/1.jpg')
					},
					{
						src: require('../assets/1.jpg')
					}
				]
      }
    }
    
  }
</script>

<style scoped>
  .fl {
    float: left;
  }

  .fr {
    float: right;
  }

  .goods .goUl {
    width: 100%;
  }

  .mr_30 {
    margin-right: 30px;
  }

  .titName {
    background: #00C5B0;
    color: #fff;
    width: 100%;
  }

  .text {
    margin-left: 10px;
  }

  .goodName {
    font-size: 18px;
    color: #fff;
    margin-left: 30px;
  }

  .mygoods {
    width: 100%;
    margin: 0 auto;
  }

  .allGood {
    width: 100%;
    background: #fff;
  }

  .icon_tit {
    width: 30px;
    height: 30px;
    margin-top: 15px;
    margin-left: 30px;
  }

  .good_title {
    width: 100%;
    height: 60px;
    line-height: 60px;
    background: #fff;
    margin: 0 auto;
    /*margin-top:20px;*/
  }

  .goodicon {
    width: 30px;
    height: 30px;
    margin-top: 6px;
  }

  .lubPic {
    width: 100%;
    height: 320px;
  }

  .lubMain {
    position: relative;
    width: 100%;
    height: 320px;
  }

  .lub {
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
    height: 320px;
  }

  .goods {
    width: 24%;
    height: 371px;
    background: #fff;
    display: inline-block;
    position: absolute;
    left: 0;
    top: 0;
    border-bottom:2px solid #00C5B0;

  }
.el-carousel__container {
    position: relative;
    height: 395px;
}
  .goods ul {
    width: 80%;
    margin: 0 auto;
  }

  .goods ul li {
    width: 100%;
    height: 53px;
    line-height: 53px;
    border-bottom: 1px solid #ccc;
    cursor: pointer;
  }
  .goods ul li:last-child{
    border-bottom:none
  }
  .el-carousel__item {
    height: 320px
  }

  .nav-breadcrumb a {
    color: #00C5B0;
  }

  .nav-breadcrumb .allgoods {
    color: #999;
  }

  .load-more {
    height: 100px;
    line-height: 100px;
    text-align: center;
  }

  .sort-up {
    transform: rotate(180deg);
    transtion: all .5s ease-out;
  }

  .banner {
    width: 100%;
    margin: 0 auto;
  }

  .catePic {
    display: inline-block;
    text-align: center;
  }

  .myCate {
    display: block;
    text-align: center;
    padding: 10px 0;
  }
  .container{
    width: 100%;
    padding: 0;
    }
.tuitu{
    display: flex;
    width: 90%;
    margin: 20px auto;
    height: 138px;
    overflow: hidden;
    padding: 0 10px;
    justify-content:space-between;
}
.Product{
 width: 90%;
 margin: 10px auto 20px;
}
.Produc_top img{
  margin-right: 10px;
 vertical-align: middle;
}
.Produc_top{
 display: flex;
 justify-content: space-between;
}
.Produc_topl{
 font-size: 16px;
 color: #4A4A4A ;
}
.Produc_topr li{
float: left;
padding: 0 10px;
border-right: 1px  solid #ccc
}
.Produc_topr li:last-child{
border-right: none;
}
.Produc_topr li a{
border-radius: 5px;
padding: 0 5px;position: relative;
}
.Produc_topr li a.cur,.Produc_topr li a:hover{
background: #00C5B0;
color: #fff
}
.Produc_topr li a::before{
background: #00C5B0;
width: 10px;
height: 10px;position: absolute;
bottom: -4px;
left: 43%;
content:"";
z-index: -1;
transform:rotate(45deg);
display: none;
}
.Produc_topr li a:hover:before{
display: block;
}
.Produc_bottom{
  border: 1px solid #ccc;
  margin: 10px 0;
  display: flex;
  height: 492px;
  overflow: hidden;
  box-sizing: unset;
}
.Produc_bottoml{
  width: 205px;
}
.qiehuan {
  width: 205px;
  position: relative;

}
.qiehuan img{
  width: 205px;
  height: 295px;
  display: block;
}
.sleft,.sright{
  position: absolute;
  display: block;
  width: 20px;
  height: 48px;
  left: 0;
  font-size: 25px;
  top: 125px;
  line-height: 44px;
  cursor: pointer;
  user-select: none;
  background: rgba(0,0,0,.4)
}
.sright{
  left: 185px
}
.Produc_bottomlist{
width: 205px;
}
.Produc_bottomlist li,.Produc_bottomlist li img{
  width: 101px;
  height: 65px;
}
.Produc_bottomlist li{
  float: left;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  box-sizing: unset;
}
.Produc_bottomr{
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 10px;
}
.Produc_bottomr li{
  margin-bottom: 20px;
}
.Produc_bottomr img{
  display: block;
  width: 290px;
  height: 178px;
}
.Produc_bottomr p.title{
  color: #000;
  font-size: 14px;
  line-height: 30px;
}
.Produc_bottomr p.price{
  color:red;
  font-size: 14px;
}
.Produc_bottomr p.price span{
  color:#999;
  text-decoration:line-through;
  padding-left: 10px;
  font-size: 12px;
}

 .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
     background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
     background-color: #d3dce6;
  }
.el-carousel {
    overflow: hidden;
}










</style>



// WEBPACK FOOTER //
// src/pages/HomePage2.vue